import React from "react";
import { Card, CardContent } from "@/components/ui/card";

const StatsCard = ({ icon: Icon, label, value, subValue, className = "" }) => (
  <Card className={`metric-card ${className}`}>
    <CardContent className="p-6">
      <div className="flex items-start justify-between">
        <div>
          <p className="data-label mb-2">{label}</p>
          <p className="data-value">{value}</p>
          {subValue && (
            <p className="text-sm text-slate-500 mt-1">{subValue}</p>
          )}
        </div>
        <div className="p-3 bg-slate-100 rounded-sm">
          <Icon className="w-5 h-5 text-slate-600" />
        </div>
      </div>
    </CardContent>
  </Card>
);

export default StatsCard;
